import { render, staticRenderFns } from "./data.html?vue&type=template&id=569d32d0&scoped=true&external"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569d32d0",
  null
  
)

export default component.exports